var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"main"},[_c('input',{ref:"cameraInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","capture":"user"},on:{"change":_vm.getPhotoAndVerify}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }